import { useEffect } from "react";

import { useIsMobile } from "../../../hooks";
import { useDebounceFn } from "../../../utils/debounce";
import { ClientsPageAnalytics, PieData, TranslatedContent } from "../../types";

export const ChartTooltipV2 = ({
  data,
  translations,
  analytics,
}: {
  data: PieData;
  translations: TranslatedContent;
  analytics?: ClientsPageAnalytics;
}) => {
  const isMobile = useIsMobile();

  const [debounceChartTooltipV2Track, cancelTooltipTrack] = useDebounceFn(
    () => {
      analytics?.trackTableChartEvent(isMobile, "Account report");
    },
    2000,
  );

  useEffect(() => {
    debounceChartTooltipV2Track();
    return () => {
      cancelTooltipTrack();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data.label) return <></>;

  const { color, label, id, value } = data;
  const borderColor = color.toString() || "bg-gray-300";

  return (
    <div
      className="relative flex rounded-xl bg-white p-3 shadow-md"
      key={`tooltip-${id}`}
    >
      <div
        className="absolute bottom-3 left-3 top-3 w-1 rounded-full bg-current"
        style={{ backgroundColor: borderColor }}
      ></div>

      <div className="flex flex-col gap-1 pl-3 text-sm">
        <div className="text-xs font-semibold text-text-primary">{label}</div>

        <div className="text-[10px] font-normal capitalize text-text-tertiary">
          {translations.accountReportTab.graphs.accounts}
        </div>
        <div className="text-xs font-semibold text-text-primary">{value}</div>
      </div>
    </div>
  );
};
